<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                    background-color="white"
                    v-model="form.name"
                    >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col> 
                <v-text-field
                    label="Abbreviation"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                    background-color="white"
                    v-model="form.abbreviation">
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from "./../../utils/validations"
export default {
    props: {
        value: Object
    },
    data() {
        return {
            idempotentKey: null,
            form: {
                name: "",
                abbreviation: ""
            }
        }
    },
    watch: {
        form: {
            handler(val) {
                this.$emit("input", val)
            },
            deep: true
        }
    },
    methods: {
        isRequired,
        validate() {
            return this.$refs.form.validate()
        },
        reset() {  
            this.form = {
                id: null,
                name: null,
                abbreviation: null
            };
            this.$refs.form.resetValidation();
            this.fetchIdempotentKey();
        },
        async get(id) {
            this.reset();
            this.form.id = id;
            this.submit("GET");
        }
    },
    mounted() {
        if(this.value) {
            this.form = {...this.form, ...this.value}
        }
    }
   
}
</script>

<style>

</style>